import * as React from "react";
import { Row, NavLink } from 'reactstrap';
// import { NavLink as RRNavLink } from 'react-router-dom';
import { timestampToMoment } from "src/share/utils/utils";
import { INotification } from "src/modules/Auth/store/types";
import environmentHelper from "src/share/utils/environmentHelper";

export interface INotificationProps {
  notification: INotification;
}

export class NotificationTransfer extends React.Component<INotificationProps>{
  constructor(props: INotificationProps) {
    super(props);
  }

  public redirectToPublicSite(caseId: string) {
    window.open(`${environmentHelper.getPublicHost()}/poster/${caseId}`, "_blank")
  }

  public render() {
    const { notification } = this.props;
    const date = timestampToMoment(notification.date);
    return (
      <div className="notification">
        <NavLink onClick={() => this.redirectToPublicSite(notification.caseId)} >
          <Row>
            <div className="dateContainer">
              <p className="date">{date.date()}</p>
              <p className="month">{date.format('MMMM')}</p>
              <p className="day">{date.format('ddd')}</p>
            </div>
            <div className="notificationContainer">
              <h5 className="title">{notification.caseId}</h5>
              <p className="subTitle"><p className="subTitle subFont">Current Agency</p>{notification.currentAgency}</p>
              <p className="subTitle"><p className="subTitle subFont">Target Agency</p>{notification.targetAgency}</p>
            </div>
          </Row>
        </NavLink>
      </div>
    );
  }
}